import { takeEvery, put, select } from 'redux-saga/effects';
import employeeHomeActions from '../actionTypes/employeeHomeActions';
import { API_CALL } from '../actionTypes/sharedActions';
import {
  GET_EMPLOYEE_HOME_DETAILS,
  EMPLOYEE_PLACE_ORDER,
  EMPLOYEE_CANCEL_ORDER,
} from '../routes';

const getEmployeeId = (state) => state.loginReducer.currentUser.id;

function* getEmployeeHomeDetails({ payload }) {
  const id = yield select(getEmployeeId);

  yield put({
    type: API_CALL,
    payload: {
      url: GET_EMPLOYEE_HOME_DETAILS.replace(':id', id),
      method: 'GET',
      params: payload,
    },
    successAction: employeeHomeActions.getEmployeeHomeDetailsSuccess,
    failureAction: employeeHomeActions.getEmployeeHomeDetailsFailed,
  });
}

function* placeOrder({ payload }) {
  yield put({
    type: API_CALL,
    payload: {
      url: EMPLOYEE_PLACE_ORDER,
      method: 'POST',
      data: { meal_id: payload },
    },
    successAction: employeeHomeActions.placeOrderSuccess,
    failureAction: employeeHomeActions.placeOrderFailed,
  });
}

function* cancelOrder({ payload }) {
  yield put({
    type: API_CALL,
    payload: {
      url: EMPLOYEE_CANCEL_ORDER.replace(':id', payload),
      method: 'POST',
      data: payload,
    },
    successAction: employeeHomeActions.cancelOrderSuccess,
    failureAction: employeeHomeActions.cancelOrderFailed,
  });
}

export default function* watchEmployeeHomeDetails() {
  yield takeEvery(
    employeeHomeActions.getEmployeeHomeDetails,
    getEmployeeHomeDetails,
  );

  yield takeEvery(employeeHomeActions.placeOrder, placeOrder);
  yield takeEvery(
    employeeHomeActions.placeOrderSuccess,
    getEmployeeHomeDetails,
  );

  yield takeEvery(employeeHomeActions.cancelOrder, cancelOrder);
  yield takeEvery(
    employeeHomeActions.cancelOrderSuccess,
    getEmployeeHomeDetails,
  );
}
